import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoadingSpinnerComponent } from '@components/shared/loading-spinner/loading-spinner.component';
import { ReportSingleService } from '@services/report-single.service';
import { TabItemComponent, TabViewComponent } from 'ngx-lib';
import { GridTabComponent } from './grid-tab/grid-tab.component';
import { OverviewTabComponent } from './overview-tab/overview-tab.component';

@Component({
    selector: 'app-report-single-tabs',
    standalone: true,
    imports: [TabViewComponent, TabItemComponent, OverviewTabComponent, GridTabComponent, LoadingSpinnerComponent],
    templateUrl: './report-single-tabs.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./report-single-tabs.component.scss']
})
export class ReportSingleTabsComponent {
    readonly service = inject(ReportSingleService);
    readonly showInitialBootstrapOverlay = computed(() => !this.service.initialBootstrapComplete());
}
